import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Article from "../pages/article/page";
import SafetyArticle from "../pages/safety/page";
import ComparisonArticle from "../pages/comparison/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hipobuy-sheet-guide",
    element: <Article />,
  },
  {
    path: "/hipobuy-sheet-safety",
    element: <SafetyArticle />,
  },
  {
    path: "/hipobuy-sheet-comparison",
    element: <ComparisonArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;